export default __webpack_public_path__ + "static/media/template_pro__0018_9---SamTrinket.7b6a183a.png";